"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onceAsync = exports.makeSignal = exports.createPromiseQueue = exports.debouncePromise = exports.delay = void 0;
const delay = (ms) => new Promise(r => setTimeout(r, ms));
exports.delay = delay;
/** 同一时刻只有一个 Promise 运行！ */
const debouncePromise = (fn) => {
    let promise;
    return (...args) => {
        if (!promise) {
            promise = fn(...args);
            promise.finally(() => {
                promise = void 0;
            });
        }
        return promise;
    };
};
exports.debouncePromise = debouncePromise;
const createPromiseQueue = () => {
    let currentPromise = Promise.resolve();
    function queue(fn) {
        return new Promise((resolve, reject) => {
            currentPromise = currentPromise.then(fn).then((res) => {
                resolve(res);
            }, (err) => {
                reject(err);
            });
        });
    }
    queue.flush = () => currentPromise;
    return queue;
};
exports.createPromiseQueue = createPromiseQueue;
const makeSignal = () => {
    let promise;
    let resolve;
    let reject;
    const reset = () => {
        promise = new Promise((res, rej) => {
            resolve = res;
            reject = rej;
        });
    };
    const resolveSignal = (value) => {
        if (!resolve)
            throw new Error('Signal resolved. Did you forget to call `reset`?');
        resolve(value);
        resolve = undefined;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        reject = undefined;
    };
    const waitSignal = (timeout = 0) => {
        const needTimeout = timeout > 0;
        const timeoutError = needTimeout && new Error('Signal timeout'); // make a error object to preserve stacktrace
        return new Promise((res, rej) => {
            const timer = needTimeout && setTimeout(() => rej(timeoutError), timeout);
            promise.then(res, rej).then(() => {
                if (timer)
                    clearTimeout(timer);
            });
        });
    };
    reset();
    resolveSignal.reset = reset;
    waitSignal.reset = reset;
    return [waitSignal, resolveSignal, reset];
};
exports.makeSignal = makeSignal;
/**
 * 只有异步函数执行完后才能进行下一个相同函数的调用
 * @param fn
 * @param getUniqueId 通过不同的id区分调用，允许多个同时调用，eg:同时打开多个不同参数的编辑弹窗
 */
function onceAsync(fn, getUniqueId) {
    const idSet = new Set();
    return async function onceAsyncFunction(...args) {
        let id;
        if (typeof getUniqueId === 'function') {
            id = getUniqueId(...args);
        }
        else {
            id = 'default';
        }
        if (idSet.has(id))
            return null;
        idSet.add(id);
        try {
            const res = await fn.apply(this, args);
            return res;
        }
        catch (error) {
            throw error;
        }
        finally {
            idSet.delete(id);
        }
    };
}
exports.onceAsync = onceAsync;
//# sourceMappingURL=promise.js.map